<div *ngIf="resource" fxLayout="column" class="forecasts-container">
    <ng-container *ngIf="model">
        <div *ngIf="model.mode === ForecastMode.MODEL"
             fxLayout="column" fxLayoutAlign="start center" class="mt-16 mb-16">
            <div fxFlex="nogrow" fxLayout="column" fxLayoutGap="6px">
                <div fxLayoutAlign="space-between" fxLayoutGap="1rem">
                    <div class="property">{{'Type'|i18n}}</div>
                    <div>
                        <app-icon [name]="model.model.type|predictiveModelIcon"></app-icon>&nbsp;
                        <em>{{model.model.type|predictiveModelType|i18n}}</em>
                    </div>
                </div>
                <div *ngFor="let detail of model.details" fxLayoutAlign="space-between" fxLayoutGap="1rem">
                    <div class="property">{{detail.param|i18n}}</div>
                    <ng-container *ngTemplateOutlet="paramValue; context: {detail: detail}"></ng-container>
                </div>
            </div>
        </div>
        <div *ngIf="model.mode === ForecastMode.STATISTICAL_PROFILE"
             fxLayout="column" fxLayoutAlign="start center" class="mt-16 mb-16">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                <div class="property">{{'Statistical profile'|i18n}}</div>
                <em>{{model.statisticalDetail|i18n}}</em>
            </div>
        </div>
    </ng-container>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="24px">
        <div class="txt-s-16-4">
            {{'Time range'|i18n}}:
        </div>
        <div>
            <app-time-filter [profile]="TimeFilterProfile.FORECAST"
                             [defaultType]="DEFAULT_TIME_FILTER"
                             (timeFilterChange)="onSelectTimeFilter($event)">
            </app-time-filter>
        </div>
    </div>
    <div class="forecasts-panel mt-20">
        <ng-container *ngIf="forecasts; else loadingForecasts">
            <div *ngIf="!forecasts.total" fxLayoutAlign="center">
                {{'No forecasts found'|i18n}}
            </div>
            <mat-accordion>
                <mat-expansion-panel *ngFor="let forecast of forecasts.forecasts; trackBy: trackByForecastId"
                                     togglePosition="before">
                    <mat-expansion-panel-header [title]="'Forecast details'|i18n">
                        <mat-panel-title>
                            <div fxLayout="row" fxLayoutAlign="space-between center" class="forecast">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div class="txt-p-14-4 mr-24 forecast-timestamp">
                                        {{forecast.forecast_timestamp|i18nTimestamp}}
                                    </div>
                                    <div class="txt-p-14-4">
                                        {{(forecast|forecastStrategy) + ' ' + ('forecast')|i18n}}
                                    </div>
                                </div>
                                <button app-icon-button class="view-forecast-button"
                                        [title]="'View forecast'|i18n"
                                        (click)="onClickGotoForecast(forecast.id, $event)">
                                    <app-icon name="fal-arrow-right"></app-icon>
                                </button>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <app-forecast-details [forecast]="forecast">
                    </app-forecast-details>
                </mat-expansion-panel>
            </mat-accordion>
        </ng-container>
        <mat-paginator #paginator app-paginator class="forecasts-paginator"
                       [ngClass]="{'collapsed': !forecasts || forecasts.total === 0}"
                       [length]="forecasts?.total" [pageSize]="PAGE_SIZE"
                       [pageSizeOptions]="PAGE_SIZES">
        </mat-paginator>
    </div>
</div>

<ng-template #paramValue let-detail="detail">
    <div *ngIf="!isDefined(detail.value)">
        <em>-</em>
    </div>
    <div *ngIf="isStringValue(detail.value)">
        <em>{{detail.value}}</em>
    </div>
    <div *ngIf="isNumericalValue(detail.value)">
        <em>{{detail.value|niceValue:detail.uom}}</em>
    </div>
    <div *ngIf="isBooleanValue(detail.value)">
        <app-icon *ngIf="detail.value" name="fal-check"></app-icon>
        <app-icon *ngIf="!detail.value" name="fal-times"></app-icon>
    </div>
</ng-template>

<ng-template #loadingForecasts>
    <div fxLayout="row" fxLayoutAlign="center center">
        <mat-spinner app-spinner diameter="20"></mat-spinner>
        <span class="pl-8">{{'Loading forecasts'|i18n}}...</span>
    </div>
</ng-template>
